export const types = {
  SET_USER_HP_READY_FOR_CUSTOMIZER:
    "HIPERPERSO_CUSTOMIZER/SET_USER_HP_READY_FOR_CUSTOMIZER",
};

export const actions = {
  setUserHPReadyForCustomizer: (ready) => ({
    type: types.SET_USER_HP_READY_FOR_CUSTOMIZER,
    ready,
  }),
};

const initialState = {
  userHPReadyForCustomizer: false,
};

const hiperpersoCustomizerReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_USER_HP_READY_FOR_CUSTOMIZER:
      return {
        ...state,
        userHPReadyForCustomizer: Boolean(action.ready),
      };
    default:
      return state;
  }
};

export default hiperpersoCustomizerReducer;
